<template>

  <v-app>

    <v-main class="py-0">
      <div class="at">

        <!-- <v-row
        justify="center" 
        style="background-image: url('https://www.dreamcity.studio/images/bg/6.jpg');" 
        class="col-12 mb-5 rounded-b-lg mx-0"> -->

        <v-row justify="center" style="background: linear-gradient(45deg,#F2CF7C, #E89A76);"
          class="col-12 pt-6 mb-5 mx-0">

          <v-col justify="center" class="col-12 col-md-6 text-center">
            <v-avatar justify="center" size="250" color="white">
              <img :src="artlist_avator">
            </v-avatar>
          </v-col>

          <v-col class="pl-5 col-12 col-md-6 text-center text-md-left">
            <h1 class="display-1 font-weight-bold my-6">
              {{ artlist_name }}
            </h1>
            <p  class="my-1" v-html="intro">
              
            </p>
            <br>

            <v-btn v-for="icon in icons" :key="icon" class="mr-4" icon>
              <a :href="icon.src" target="_blank">
                <v-icon x-large color="white">
                  {{ icon.ico }}
                </v-icon>
              </a>
            </v-btn>
            <v-btn class="mr-4" icon>
              <a :href="tw_share" target="_blank">
                <v-icon x-large color="white">
                  mdi-share
                </v-icon>
              </a>
            </v-btn>

          </v-col>
        </v-row>

        <!-- 分頁切換 -->
        <v-tabs v-model="tab" align-with-title>
          <v-tab v-for="item in tab_list" :key="item" class="text-h6 mr-6" style="font-weight: 600;">
            {{ item }}
          </v-tab>

        </v-tabs>
        <v-divider></v-divider>
        <v-tabs-items v-model="tab">
          <v-tab-item key="作品集">
            <art />
          </v-tab-item>
          <v-tab-item key="委託須知">
            <info />
          </v-tab-item>
          <v-tab-item key="收費與授權">
            <cost />
          </v-tab-item>
        </v-tabs-items>

      </div>
    </v-main>
  </v-app>
</template>

<script>

import art from './components/art';
import info from './components/info';
import cost from './components/cost';

export default {

  components: {
    art,
    info,
    cost,
  },

  data: () => ({
    artlist_name: "夜瑀",
    artlist_avator: "https://www.dreamcity.studio/about/images/34.jpg",
    intro: 
      '嗨，我叫夜瑀。一位熱衷於Minecraft動畫的動畫師。<br>目標是利用劇情、建模和光影等，發展出獨特的風格，請多指教！',
    icons: [
      { ico: 'mdi-facebook', src: "https://www.facebook.com/bscgameplayer" },
      { ico: 'mdi-twitter', src: "https://twitter.com/Yei_Yui" },
      { ico: 'mdi-youtube', src: "https://www.youtube.com/@YeiYu/videos" },
      { ico: 'mdi-email', src: "mailto:	bscgameplayer@gmail.com" },
    ],
    tab: null,
    tab_list: [
      '作品集',
      '委託須知',
      '收費與授權',
    ],
    tw_share: "https://twitter.com/intent/tweet?text=夜瑀https://www.dreamcity.studio/art/yeiyu",

  }),

}
</script>

<style scoped>
.at {
  width: 100%;
  margin-right: auto;
  margin-left: auto;
}

@media (min-width: 1264px) {
  .at {
    max-width: 1920px;
  }
}
</style>
